import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import './KpiInfo.css';

const afficherFiltres = (filtres = []) => filtres.filter((item) => item?.valeur != null && item.valeur !== '').map((item) => `${item.nom} : ${item.valeur}`);

export default function KpiInfo({ titre, definition, formule, periode, filtres = [], sansIncidence = [], source, certification }) {
  const [ouvert, setOuvert] = useState(false);
  const [position, setPosition] = useState(null);
  const racine = useRef(null);
  const bulle = useRef(null);
  useEffect(() => {
    if (!ouvert) return undefined;
    const fermer = (event) => {
      if (!racine.current?.contains(event.target) && !bulle.current?.contains(event.target)) setOuvert(false);
    };
    const clavier = (event) => { if (event.key === 'Escape') setOuvert(false); };
    document.addEventListener('pointerdown', fermer);
    document.addEventListener('keydown', clavier);
    return () => { document.removeEventListener('pointerdown', fermer); document.removeEventListener('keydown', clavier); };
  }, [ouvert]);
  useLayoutEffect(() => {
    if (!ouvert || !racine.current || !bulle.current) return undefined;
    const placer = () => {
      const ancre = racine.current.getBoundingClientRect();
      const panneau = bulle.current.getBoundingClientRect();
      const marge = 14;
      const espaceDroite = window.innerWidth - ancre.right - marge;
      const espaceGauche = ancre.left - marge;
      const ouvrirDroite = ancre.left < window.innerWidth / 2 || espaceDroite >= espaceGauche;
      const gaucheSouhaitee = ouvrirDroite ? ancre.left : ancre.right - panneau.width;
      const left = Math.max(marge, Math.min(gaucheSouhaitee, window.innerWidth - panneau.width - marge));
      const espaceBas = window.innerHeight - ancre.bottom - marge;
      const hautSouhaite = espaceBas >= panneau.height ? ancre.bottom + 8 : ancre.top - panneau.height - 8;
      const top = Math.max(marge, Math.min(hautSouhaite, window.innerHeight - panneau.height - marge));
      setPosition({ left, top });
    };
    placer();
    window.addEventListener('resize', placer);
    window.addEventListener('scroll', placer, true);
    return () => { window.removeEventListener('resize', placer); window.removeEventListener('scroll', placer, true); };
  }, [ouvert]);
  const filtresAffiches = afficherFiltres(filtres);
  const stopper = (event) => event.stopPropagation();
  const contenu = ouvert ? <span
    className="kpi-info-popover"
    ref={bulle}
    role="tooltip"
    style={position || { left: 14, top: 14, visibility: 'hidden' }}
    onClick={stopper}
    onPointerDown={stopper}
  >
    <strong className="kpi-info-title">{titre}</strong>
    <b>Définition</b><span>{definition}</span>
    <b>Formule</b><span>{formule}</span>
    <b>Période</b><span>{periode}</span>
    <b>Filtres appliqués</b><span>{filtresAffiches.length ? filtresAffiches.join(' · ') : 'Aucun'}</span>
    {!!sansIncidence.length && <><b>Filtres sans incidence</b><span>{sansIncidence.join(' · ')}</span></>}
    <b>Source</b><span>{source}</span>
    <b>Certification</b><span className={`kpi-info-certification ${String(certification).includes('CERTIFIÉ') && !String(certification).includes('NON') && !String(certification).includes('À ') ? 'certified' : ''}`}>{certification}</span>
    <button type="button" className="kpi-info-close" onClick={() => setOuvert(false)}>Fermer</button>
  </span> : null;
  return <span className={`kpi-info ${ouvert ? 'open' : ''}`} ref={racine} onClick={stopper} onPointerDown={stopper}>
    <button type="button" className="kpi-info-trigger" aria-label={`Explication du KPI ${titre}`} aria-expanded={ouvert} onClick={(event) => { event.stopPropagation(); setOuvert((courant) => !courant); }}>ⓘ</button>
    {contenu && createPortal(contenu, document.body)}
  </span>;
}

export const formatPeriodeKpi = (debut, fin) => `${String(debut || '—').split('-').reverse().join('/')} → ${String(fin || '—').split('-').reverse().join('/')}`;
